import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  exportData(request: Boundaries["exportData"]["request"]): void;
}

function useExportData(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isExportDataRequestPending),
    isRequestSuccess: useSelector(selector.isExportDataRequestSuccess),
    isRequestFailure: useSelector(selector.isExportDataRequestFailure),
    exportData: core.exportData,
  };
}

export { useExportData };
